export default __webpack_public_path__ + "static/media/498.5f3b2fdd.png";